var React = require('react');
var Input = require('./../../input');
var Color = require('./../../color_input');

var createReactClass = require('create-react-class');
module.exports = createReactClass({

  displayName: 'SignControls',

  render : function () {
    return (
      <div className="customization-controls">
        <Color
          label="Background Color"
          name="background_color"
          defaultValue={this.props.background_color}
          onChange={this.props.onChange.bind(null, 'background_color')} />
        <Color
          label="Primary Text Color"
          name="primary_text_color"
          defaultValue={this.props.primary_text_color}
          onChange={this.props.onChange.bind(null, 'primary_text_color')} />
        <Color
          label="Secondary Text Color"
          name="secondary_text_color"
          defaultValue={this.props.secondary_text_color}
          onChange={this.props.onChange.bind(null, 'secondary_text_color')} />
        <Color
          label="Sign Frame Color"
          name="sign_frame_color"
          defaultValue={this.props.sign_frame_color}
          onChange={this.props.onChange.bind(null, 'sign_frame_color')} />
        <Color
          label="Sign Text Color"
          name="sign_text_color"
          defaultValue={this.props.sign_text_color}
          onChange={this.props.onChange.bind(null, 'sign_text_color')} />
        <Color
          label="Sign Background Color"
          name="sign_background_color"
          defaultValue={this.props.sign_background_color}
          onChange={this.props.onChange.bind(null, 'sign_background_color')} />
        <Color
          label="Button Color"
          name="button_color"
          type="text"
          defaultValue={this.props.button_color}
          onChange={this.props.onChange.bind(null, 'button_color')} />
      </div>
    )
  }

});



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/controls/sign.jsx